import React from "react";
import HeroSections from "../component/homeComponnets/heroSections";
import ServiceSections from "../component/homeComponnets/servicesection";
import AboutSections from "../component/homeComponnets/aboutsections";
import WhyChooseUs from "../component/homeComponnets/whyChoose";
import SolutionsSection from "../component/homeComponnets/solutionssections";
import ClientCarousel from "../component/ourClient";
import ProjectSection from "../component/homeComponnets/projectSection";
import StatsSection from "../component/homeComponnets/startSection";

export default function Home() {
  return (
   <div>
    <HeroSections/>
    <AboutSections />
    <ServiceSections/>
    <WhyChooseUs />
    <StatsSection />
    <ProjectSection />
    <SolutionsSection />
    <ClientCarousel/>
   </div>
  );
}

